import { useCallback } from 'react';
import { FORM_MODES } from 'config/formModes';
import { useNavigate } from 'hooks';
import { generateCampaignGroupEditorPath } from 'modules/campaigns/services/utils';
import { useAccount } from 'modules/taboola-common-frontend-modules/account-configurations';

export const useOpenCampaignsGroupDuplicate = () => {
    const navigate = useNavigate();
    const { accountId } = useAccount();

    return useCallback(
        campaignsGroup => {
            const { campaignsGroupId } = campaignsGroup;
            const duplicateCampaignGroupPath = generateCampaignGroupEditorPath({
                mode: FORM_MODES.DUPLICATE,
                accountId,
                formEntityIds: [campaignsGroupId],
            });

            navigate(duplicateCampaignGroupPath);
        },
        [accountId, navigate]
    );
};
